var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMagnifyingGlassSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "magnifying-glass-small"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-1",
    d: "M14,4a10,10,0,0,1,7.77,16.29L28,26.52,26.52,28l-6.23-6.23A10,10,0,1,1,14,4Zm0,2a8,8,0,1,0,8,8A8,8,0,0,0,14,6Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifyingGlassSmall);
export default __webpack_public_path__ + "static/media/magnifying-glass-small.16aa4662.svg";
export { ForwardRef as ReactComponent };